module.exports = __webpack_public_path__ + "static/media/Download_Salary_Disabled.98fcc487.svg";